<template>
  <div class="history">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>设备扣分详情</span>
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <!-- 甲方单位 -->
        <el-col :span="4">
          <el-select
            v-model="firstValue"
            @change="changePartyName"
            placeholder="请选择甲方单位"
            clearable
          >
            <el-option
              v-for="item in firstCompanys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- 维度下拉 -->
        <el-col :span="4">
          <el-select
            class="select"
            v-model="typeValue"
            placeholder="请选择维度"
            @change="changeType"
          >
            <el-option
              v-for="item in type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- 时间选择 -->
        <el-col :span="7">
          <el-date-picker
            v-model="pickerDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-col>
        <!-- 搜索 -->
        <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="search"
          ></el-button>
        </el-col>
        <el-col :span="7">&nbsp;</el-col>
        <!-- 下载 -->
        <el-col :span="1">
          <el-button
            v-if="tableData.length != 0"
            icon="el-icon-download"
            type="info"
            plain
            :loading="downloadLoading"
            @click="download"
          ></el-button>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <!-- <TzTable :tableData="tableData" :columns="columns" /> -->
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column
          label="设备名称"
          prop="deviceName"
          sortable
        ></el-table-column>
        <el-table-column
          label="扣分问题"
          prop="defectcodeName"
          sortable
        ></el-table-column>
        <el-table-column
          label="严重等级"
          prop="levelcodeName"
          sortable
        ></el-table-column>
        <el-table-column label="扣分数" prop="score" sortable></el-table-column>
        <el-table-column
          label="状态"
          prop="statusName"
          sortable
        ></el-table-column>

        <el-table-column
          label="创建时间"
          prop="createDate"
          sortable
        ></el-table-column>
        <el-table-column label="扣分图片" prop="filepath" width="180">
          <template slot-scope="scope">
            <el-popover placement="left" width="250" trigger="hover">
              <div>
                <img
                  :src="getImgUrl(scope.row.filepath)"
                  style="width: 250px; height: 350px"
                />
              </div>

              <img
                slot="reference"
                :src="getImgUrl(scope.row.filepath)"
                style="width: 100px; height: 100px"
                alt="image"
              />
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import table2excel from 'js-table2excel'
import { queryPartyaNames, inspectQuestionInfo } from '@/api/inspect'
export default {
  components: {},
  data() {
    return {
      pickerDate: [], //日期 时间戳
      offset: '', //当前起始位置（page-1）*limit
      page: 1, //当前页
      limit: '10', //
      total: '',
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },

      downloadLoading: false,

      // 甲方单位
      firstCompanys: [],
      firstValue: '', //选中甲方
      // 维度
      type: [
        {
          value: '1',
          label: '项目'
        },
        {
          value: '2',
          label: '安装单位'
        },
        {
          value: '3',
          label: '制造单位'
        },
        {
          value: '4',
          label: '设备类型'
        }
      ],
      typeValue: '4', //选中维度

      // 表格列
      // columns: [
      //   { title: '名称', field: 'name' },
      //   { title: '得分', field: 'score' },
      //   {
      //     title: '图片',
      //     field: 'image',
      //     type: 'image'
      //   }
      // ],
      // 表格数据
      tableData: []
    }
  },
  methods: {
    handleSizeChange(val) {
      this.limit = val
      // console.log(this.limit, this.page)
      this.inspectQuestionInfo(this.typeValue)
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.page = val
      // console.log(this.limit, this.page)
      this.inspectQuestionInfo(this.typeValue)
      // console.log(`当前页: ${val}`)
    },
    //选择日期事件
    handleDateChange(pickerDate) {
      console.log(pickerDate)
    },
    //甲方下拉框
    changePartyName(firstValue) {
      console.log(firstValue)
      this.firstValue = firstValue
    },
    //甲方单位
    queryPartyaNames() {
      queryPartyaNames().then((res) => {
        this.firstCompanys = res.data
      })
    },
    //维度下拉选择
    changeType(typeValue) {
      console.log(typeValue)
      this.typeValue = typeValue
    },
    // 点击搜索
    search() {
      if (this.typeValue == '' || this.pickerDate.length == 0) {
        this.$message({
          message: '请选择搜索条件',
          type: 'warning'
        })
      } else {
        //数据请求
        this.inspectQuestionInfo(this.typeValue)
      }
    },
    // 扣分详情
    inspectQuestionInfo(deviceType) {
      // var page = this.page + 1
      var data = {
        deviceType, //设备类型
        partyaName: this.firstValue,
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        offset: (this.page - 1) * this.limit,
        limit: this.limit
      }

      inspectQuestionInfo(data).then((res) => {
        console.log(res.data)
        this.total = res.data.total
        if (res.data.length == 0) {
          this.tableData = []
          this.$message({
            message: '暂无数据'
          })
        } else {
          this.tableData = res.data.rows
        }

        console.log('扣分详情')
      })
    },
    download() {
      console.log(this.tableData, 'kkk')
      // this.downloadLoading = true
      const column = [
        {
          title: '设备名称',
          key: 'deviceName',
          type: 'text'
        },

        {
          title: '扣分问题',
          key: 'defectcodeName',
          type: 'text'
        },
        {
          title: '严重等级',
          key: 'levelcodeName',
          type: 'text'
        },
        {
          title: '扣分数',
          key: 'score',
          type: 'text'
        },
        {
          title: '状态',
          key: 'statusName',
          type: 'text'
        },
        {
          title: '创建时间',
          key: 'createDate',
          type: 'text'
        },
        {
          title: '扣分图片',
          key: 'filepath',
          type: 'image',
          width: 279,
          height: 107
        }
      ]
      let tableData = this.formatJson(this.tableData)
      table2excel(column, tableData, '设备扣分详情.xls')
    },
    // 图片地址拼接
    formatJson(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].filepath) {
          data[i].filepath = this.getImgUrl(data[i].filepath)
        }
      }
      return data
    }
  },
  created() {
    this.queryPartyaNames()
    this.inspectQuestionInfo(this.typeValue)
    console.log(this.tableData)
  }
}
</script>

<style lang="scss" scoped>
el-col {
}
</style>
